module.exports = __webpack_public_path__ + "img/car.4ebf9be4.jpg";